import { MarkdownContent } from 'src/components/markdown-content'
import { useTranslation } from 'react-i18next'
import { Navigate, useParams, useSearchParams } from 'react-router'
import { getLegalDocument, isLegalDocKey } from 'src/content/legal'

export const LegalPage = () => {
  const { t, i18n } = useTranslation()
  const { doc } = useParams()
  const [searchParams] = useSearchParams()
  if (!isLegalDocKey(doc)) return <Navigate to="/" replace />
  const { version, effectiveDate, body } = getLegalDocument(
    doc,
    searchParams.get('lang') ?? i18n.language,
    searchParams.get('country'),
  )

  return (
    <div className="mx-auto max-w-3xl px-6 py-10" data-testid="legal-page">
      <p
        role="note"
        data-testid="legal-pending-review"
        className="mb-6 rounded-md border border-warning bg-white p-3 text-sm text-gray-800"
      >
        {t('legal.pendingReview')}
      </p>
      <p className="mb-6 text-sm text-gray-600" data-testid="legal-version">
        {t('legal.version', { version })} · {t('legal.effectiveDate', { date: effectiveDate })}
      </p>
      <MarkdownContent>{body}</MarkdownContent>
    </div>
  )
}
